import classNames from 'classnames';
import { ReactNode } from 'react';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import styles from './TableRow.module.scss';

type TableRowProps = {
  className?: string;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  label: ReactNode;
  /** Tooltip shown on hover over the label. Falls back to the label when it is a string. Useful when label is a non-string node but is visually truncated. */
  labelTitle?: string;
  description?: ReactNode;
};

const TableRow = ({ className, leftContent, rightContent, label, labelTitle, description }: TableRowProps) => {
  return (
    <div {...setDenaliAttribute('TableRow')} className={classNames(styles.container, className)}>
      {leftContent}
      <div className={styles.textContent}>
        <div className={styles.label} title={labelTitle ?? (typeof label === 'string' ? label : undefined)}>
          {label}
        </div>
        {description && (
          <div className={styles.description} title={typeof description === 'string' ? description : undefined}>
            {description}
          </div>
        )}
      </div>
      {rightContent}
    </div>
  );
};

export default TableRow;
